import { Field, RichTextField } from '@sitecore-jss/sitecore-jss-nextjs';
import {
  AnchorTargetParams,
  DynamicPlaceholderParams,
  RenderingProps,
  TranslationOptionsParams,
} from '@/shared/shared.types';

export type C36AccordionEnhancedProps = RenderingProps<
  C36AccordionEnhancedFields,
  C36AccordionEnhancedParams,
  C36AccordionEnhancedPlaceholder
>;

export type C36AccordionEnhancedFields = {
  Headline?: Field<string>;
  SupportCopy?: RichTextField;
  SupportCopyBottom?: RichTextField;
};

export type C36AccordionEnhancedParams = {
  HeadlineTag?: string;
  HeadlineIcon?: string;
  HeadlineIconPlacement?: string;
  HeadlineAlignment?: string;
  BackgroundColor?: string;
  OpenFirstItem?: boolean;
  LimitToSingleItem?: boolean;
} & DynamicPlaceholderParams &
  TranslationOptionsParams &
  AnchorTargetParams;

export type C36AccordionEnhancedPlaceholder = {
  'accordion-enhanced-item-container'?: {
    componentName?: string;
    uid?: string;
  }[];
};
